// src/utils/mockAuth.js
// Sistema di mock per l'autenticazione quando il backend non è disponibile

// Dati utente mock
const MOCK_USER = {
  id: 1,
  username: 'dev_user',
  email: 'dev@example.com',
  first_name: 'Dev',
  last_name: 'User',
  role: 'manager', // Puoi cambiare in 'user' o 'manager' o 'superuser'
  is_superuser: true, // Cambia a false se non vuoi i permessi superuser
  tenant: {
    id: 1,
    name: 'Dev Tenant'
  }
};

// Token mock (non sono token JWT reali, ma stringhe che simulano il comportamento)
const MOCK_ACCESS_TOKEN = 'mock_access_token_' + Date.now();
const MOCK_REFRESH_TOKEN = 'mock_refresh_token_' + Date.now();

/**
 * Verifica se il mock deve essere attivo
 * Attivo se:
 * - REACT_APP_USE_MOCK_AUTH è 'true'
 * - O se il backend non è raggiungibile (gestito in axios.js)
 */
export const shouldUseMockAuth = () => {
  return process.env.REACT_APP_USE_MOCK_AUTH === 'true';
};

/**
 * Mock della risposta del login
 */
export const mockLogin = (username, password) => {
  // Simula un piccolo delay come una vera chiamata API
  return new Promise((resolve) => {
    setTimeout(() => {
      // Accetta qualsiasi username/password in modalità mock
      console.log('🔧 [MOCK AUTH] Login effettuato con:', username);
      
      resolve({
        data: {
          access: MOCK_ACCESS_TOKEN,
          refresh: MOCK_REFRESH_TOKEN
        }
      });
    }, 500);
  });
};

/**
 * Mock della risposta del refresh token
 */
export const mockRefreshToken = (refreshToken) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('🔧 [MOCK AUTH] Token refresh effettuato');
      
      resolve({
        data: {
          access: 'mock_access_token_' + Date.now()
        }
      });
    }, 300);
  });
};

/**
 * Mock della risposta per ottenere l'utente corrente
 */
export const mockGetCurrentUser = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('🔧 [MOCK AUTH] Dati utente mock restituiti');
      
      resolve({
        data: MOCK_USER
      });
    }, 300);
  });
};

/**
 * Verifica se un errore è dovuto al backend non disponibile
 */
export const isBackendUnavailable = (error) => {
  if (!error.response) {
    // Network error o backend non raggiungibile
    return true;
  }
  
  // Errore 500, 502, 503, 504 indicano problemi del server
  const serverErrors = [500, 502, 503, 504];
  if (error.response.status && serverErrors.includes(error.response.status)) {
    return true;
  }
  
  return false;
};
